import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-720bb67c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "text-2xl p-4" }
const _hoisted_3 = {
  key: 0,
  class: "border p-2 mb-2 rounded text-red-600 border-red-400 bg-red-100 dark:text-dark-text dark:border-red-900 dark:bg-red-900"
}
const _hoisted_4 = { style: {"width":"30vw"} }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-sm ml-1",
  for: "id"
}, " ID ", -1))
const _hoisted_7 = {
  class: "text-sm ml-1",
  for: "password"
}
const _hoisted_8 = { class: "flex justify-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTextButton = _resolveComponent("IconTextButton")!
  const _component_PrimaryModal = _resolveComponent("PrimaryModal")!

  return (_openBlock(), _createBlock(_component_PrimaryModal, {
    onClickBackground: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('message.login')), 1),
        (_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('message.loginFailed')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.id) = $event)),
              class: _normalizeClass(["mt-1", _ctx.isLightMode() ? 'input' : 'input-dark']),
              placeholder: "Account ID",
              required: "",
              type: "text"
            }, null, 2), [
              [_vModelText, _ctx.id]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('message.password')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              class: _normalizeClass(["mt-1 focus:outline-none", _ctx.isLightMode() ? 'input' : 'input-dark']),
              placeholder: "**********",
              required: "",
              type: "password"
            }, null, 2), [
              [_vModelText, _ctx.password]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_IconTextButton, {
              border_radius: 2,
              class: "mx-1",
              font_weight: '700',
              icon: 'person_add',
              iconSize: 'text-xl',
              padding_bottom: 4,
              padding_left: 10,
              padding_right: 10,
              padding_top: 4,
              text: _ctx.$t('message.createNewAccount'),
              textSize: 'text-base',
              onClick: _ctx.onClickCreateAccount
            }, null, 8, ["text", "onClick"]),
            _createVNode(_component_IconTextButton, {
              border_radius: 2,
              class: "mx-1",
              font_weight: '700',
              icon: 'login',
              iconSize: 'text-xl',
              padding_bottom: 4,
              padding_left: 10,
              padding_right: 10,
              padding_top: 4,
              text: _ctx.$t('message.login'),
              textSize: 'text-base',
              onClick: _ctx.onClickLogin
            }, null, 8, ["text", "onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}